// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import "font-awesome/css/font-awesome.css"
import $ from 'jquery';
import Vue from 'vue';
import store from './store';
import App from './App';
import router from './router';
import common from './components/common';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import md5 from 'js-md5';

import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


//*************语言包方法**************
import { VueLanguage } from './utils/language';
Vue.use(VueLanguage)
//*************语言包方法end**************


//*************读取语言方法*************
//设置默认语言
let languageData = store.state.language || 'en';
Vue.prototype.optionLanuage(languageData)
//*************读取语言方法end*************

// 谷歌登陆插件
import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton);

//facebook登陆
import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)

//注册全局过滤器
import filters from './filters';
Object.keys(filters).forEach(key => {
  console.log(key)
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

Vue.use(common);

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import './assets/css/swiper.min.css'
Vue.prototype.$md5 = md5;
Vue.use(VueAwesomeSwiper, /* { default global options } */)

// 引入全局注册组件
import './components';


//mian.js中：google地图api
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    //填入申请的apiKey账号
    apiKey: 'AIzaSyCCl_9chJcEjufulKVpvX8pEaSuEZKE8UE',
    libraries: ['places'],
    useBetaRenderer: false,
  },
})

const IE11RouterFix = {
  methods: {
    hashChangeHandler: function () { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
    isIE11: function () { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function () { if (this.isIE11()) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function () { if (this.isIE11()) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mixins: [IE11RouterFix],
  activated() {

  },
  mounted() {
    this.setSize();
  },
  methods: {
    isTabRoute: function () {
      var that = this;
      $(window).scrollTop(0)

    }
  },

  watch: {
    '$route': 'isTabRoute',
  }
})


Date.prototype.format = function(fmt) { 
  var o = { 
     "M+" : this.getMonth()+1,                 //月份 
     "d+" : this.getDate(),                    //日 
     "h+" : this.getHours(),                   //小时 
     "m+" : this.getMinutes(),                 //分 
     "s+" : this.getSeconds(),                 //秒 
     "q+" : Math.floor((this.getMonth()+3)/3), //季度 
     "S"  : this.getMilliseconds()             //毫秒 
 }; 
 if(/(y+)/.test(fmt)) {
         fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
 }
  for(var k in o) {
     if(new RegExp("("+ k +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
  }
 return fmt; 
} 


// WEBPACK FOOTER //
// ./src/main.js